import React from 'react';
import './CTA.css';

const CTAContainer = ({ 
  children, 
  className = '', 
  responsive = true // Enable responsive behavior
}) => {
  return (
    <div 
      className={`cta-container ${className} ${responsive ? 'cta-container--responsive' : ''}`}
    >
      {children}
    </div>
  );
};

export default CTAContainer;
